import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84cd10e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "请选择要批改的保单", -1))
const _hoisted_4 = { class: "list-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "van-hairline--surround list-item" }
const _hoisted_7 = { class: "head-line" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "tag-wrap" }
const _hoisted_10 = { class: "info-item" }
const _hoisted_11 = { class: "info-item" }
const _hoisted_12 = {
  key: 0,
  class: "empty-text"
}
const _hoisted_13 = {
  key: 0,
  class: "footer xag-page__footer nongfu-button-wrap"
}
const _hoisted_14 = { class: "footer-left nongfu-checkbox-wrap" }

import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Button, Checkbox } from 'vant'
import { ClientJijiaInsuranceListItem } from '@/types/insurance'
import { getClientJijiaInsuranceList } from '@/apis/insurance'
import { commonErrorHandle } from '@/utils/error-handle'
import { showToastLoading, clearToast } from '@/utils/tools'
import {
  getInsuranceStatusClassName,
  getInsuranceStatusDesc,
  judgeInsuranceItemCanCorrect,
  getJijiaInsuranceCorrectListSortWeight,
} from '../common'
import AppHeader from '@/components/Header.vue'
import insuranceTagItem from '../components/insurance-tag-item.vue'
import InsuranceCorrectPopup from '../components/insurance-correct-popup.vue'

type SelectRenderItem = ClientJijiaInsuranceListItem & {
  tagClass: string
}


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'insurance-jijia-insurance-correct-select',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $route = useRoute()
const $router = useRouter()
const eq_sn = $route.query.eq_sn as string
const loading = ref(false)
const selectableList = ref<SelectRenderItem[]>([])
const selectedIds = ref<number[]>([])
const showCorrectPopup = ref(false)

const selectedItems = computed(() => {
  return selectableList.value.filter((item) => selectedIds.value.includes(item.id))
})

const isAllSelected = computed({
  get() {
    return (
      selectableList.value.length > 0 &&
      selectableList.value.every((item) => selectedIds.value.includes(item.id))
    )
  },
  set(checked: boolean) {
    selectedIds.value = checked ? selectableList.value.map((item) => item.id) : []
  },
})

function mapListItem(item: ClientJijiaInsuranceListItem): SelectRenderItem {
  return {
    ...item,
    status_desc: getInsuranceStatusDesc(item.status, item.status_desc),
    tagClass: getInsuranceStatusClassName(item.status, item.status_desc),
  }
}

function sortJijiaCorrectList(items: ClientJijiaInsuranceListItem[]) {
  return [...items].sort(
    (a, b) =>
      getJijiaInsuranceCorrectListSortWeight(a.status, a.status_desc) -
      getJijiaInsuranceCorrectListSortWeight(b.status, b.status_desc)
  )
}

async function fetchAllPolicies() {
  const all: ClientJijiaInsuranceListItem[] = []
  let page = 1
  let lastPage = 1
  while (page <= lastPage) {
    const data = await getClientJijiaInsuranceList({
      eq_sn,
      page,
      per_page: 20,
    })
    all.push(...data.data)
    lastPage = data.last_page || Math.ceil(data.total / 20) || 1
    page++
  }
  return all
}

async function initPageData() {
  loading.value = true
  showToastLoading()
  try {
    const data = await fetchAllPolicies()
    selectableList.value = sortJijiaCorrectList(data.filter(judgeInsuranceItemCanCorrect)).map(
      mapListItem
    )
    selectedIds.value = []
  } catch (error) {
    commonErrorHandle(error)
  } finally {
    loading.value = false
    clearToast()
  }
}

function toggleSelect(id: number, checked?: boolean) {
  const isChecked = typeof checked === 'boolean' ? checked : !selectedIds.value.includes(id)
  if (isChecked) {
    if (!selectedIds.value.includes(id)) {
      selectedIds.value = [...selectedIds.value, id]
    }
    return
  }
  selectedIds.value = selectedIds.value.filter((itemId) => itemId !== id)
}

function confirmHandle() {
  if (selectedIds.value.length === 0) {
    return
  }
  showCorrectPopup.value = true
}

function onCorrectSuccess() {
  if (eq_sn) {
    sessionStorage.setItem('jijiaInsuranceListNeedRefresh', eq_sn)
  }
  $router.back()
}

onMounted(() => {
  void initPageData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "批改被保人" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectableList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "list-row",
              onClick: ($event: any) => (toggleSelect(item.id))
            }, [
              _createElementVNode("div", {
                class: "checkbox-wrap nongfu-checkbox-wrap",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_unref(Checkbox), {
                  "model-value": selectedIds.value.includes(item.id),
                  "onUpdate:modelValue": (checked) => toggleSelect(item.id, checked)
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(item.product_info.product_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(insuranceTagItem, {
                      text: item.status_desc,
                      className: item.tagClass
                    }, null, 8, ["text", "className"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, "保单号：" + _toDisplayString(item.policy_no), 1),
                _createElementVNode("div", _hoisted_11, " 保险时间：" + _toDisplayString(item.policy_start_at ? item.policy_start_at.split(' ')[0] : '') + " 至 " + _toDisplayString(item.policy_end_at ? item.policy_end_at.split(' ')[0] : ''), 1)
              ])
            ], 8, _hoisted_5))
          }), 128)),
          (!loading.value && selectableList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "暂无可批改保单"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (selectableList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(Checkbox), {
              modelValue: _unref(isAllSelected),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isAllSelected) ? (isAllSelected).value = $event : null))
            }, {
              default: _withCtx(() => [
                _createTextVNode("全选")
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_unref(Button), {
            class: "confirm-button xa-vant-button",
            disabled: selectedIds.value.length === 0,
            onClick: confirmHandle
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(InsuranceCorrectPopup, {
      show: showCorrectPopup.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showCorrectPopup).value = $event)),
      jijiaItem: _unref(selectedItems)[0],
      jijiaItems: _unref(selectedItems),
      onSuccess: onCorrectSuccess
    }, null, 8, ["show", "jijiaItem", "jijiaItems"])
  ], 64))
}
}

})